import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Form, Button, Alert } from 'react-bootstrap';
import { Formik } from 'formik';
import * as Yup from "yup";
import FacebookLogin, { FacebookLoginClient } from '@greatsumini/react-facebook-login';
import { gapi } from 'gapi-script';
import { accountService } from '../functions/registerMemberApi';
import PhoneInput from 'react-phone-input-2';
import PinInput from 'react-pin-input';
import { TailSpin } from 'react-loader-spinner';

import 'react-phone-input-2/lib/high-res.css';
import '../scss/RegisterMember.scss';
import { faLessThanEqual } from '@fortawesome/free-solid-svg-icons';

const RegisterMember = ({ userID, setUserID, login, setLogin, setUserName }) => {
    const navigate = useNavigate();
    const Ref = useRef(null);
    const [loading1, setLoading1] = useState(false);
    const [loading2, setLoading2] = useState(false);
    const [loading3, setLoading3] = useState(false);


    const [signUpStage, setSignUpStage] = useState(1);
    const [signUpErr, setSignUpErr] = useState(false);
    const [signUpMessage, setSignUpMessage] = useState('');

    const initialValues = {
        firstname : '',
        lastname : '',
        phone: '',
        email : '',
        password : '',
        terms: false,
    }
    const [userData, setUserData] = useState(initialValues);
    
    const SignUpSchema1 = Yup.object().shape({
        firstname: Yup.string()
          .min(2, "Too Short!")
          .max(50, "Too Long!")
          .required("First name is required"),
      
        lastname: Yup.string()
          .min(2, "Too Short!")
          .max(50, "Too Long!")
          .required("Last name is required"),
      
        // phoneNumber: Yup.string()
        //   .required("Phone number is required")
        //   .matches(
        //     /^([0]{1}|\+?[234]{3})([7-9]{1})([0|1]{1})([\d]{1})([\d]{7})$/g,
        //     "Invalid phone number"
        //   ),
      
        email: Yup.string().email().required("Email is required"),
      
        password: Yup.string()
          .required("Password is required")
          .min(8, "Password is too short - should be 8 chars minimum"),

        terms: Yup.bool().required().oneOf([true], 'Terms must be accepted'),
    });

    const submitForm = (values) => {
        console.log(values);

        setSignUpErr(false);
        setLoading1(true);

        accountService.signUp1(values)
            .then(response => {
                console.log(response);
                if(response.status)
                {
                    const data = response.body;
                    setUserID(data.individualID);
                    setSignUpStage(2);
                    setLoading1(false);
                }
                else
                {
                    const err = response.body;
                    setSignUpErr(true);
                    setSignUpMessage(err.message);
                    setLoading1(false);
                }
            })
            .catch(err => {
                console.error(err);
                setLoading1(false);
            });
    };


    // Facebook Login
    const FacebookAppID = '1062638818471522';

    const responseFacebook = (response) => {
        console.log(response);
        // Login failed
        if (response.status === "unknown") {
            alert("Login failed!");
            setLogin(false);
            return false;
        }

        if (response.accessToken) {
            setLogin(true);
        } else {
            setLogin(false);
        }
    };
    const responseFacebookProfile = (response) => {
        console.log(response);
        // setData(response);
        // setPicture(response.picture.data.url);

        FacebookLoginClient.getProfile((response) => {
            console.log(response.id, response.name, response.email);
        });
    }
    const FacebookLogout = () => {
        setLogin(false);
        // setData({});
        // setPicture("");
    };



    const initialValues2 = {
        contact: '',
        mykad: '',
        gender: '',
        dob: '',
        nationality: '',
        country : '',
        city: '',
        state: '',
        address: '',
        postcode: ''
    }
    const [personalInfo, setPersornalInfo] = useState(initialValues2);

    const SignUpSchema2 = Yup.object().shape({
        contact: Yup.string()
            .min(10, "Too Short!")
            .required("Contact number is required"),
            // .matches(
            //     /^([0]{1}|\+?[234]{3})([7-9]{1})([0|1]{1})([\d]{1})([\d]{7})$/g,
            //     "Invalid phone number"
            // ),
        
        mykad: Yup.string()
            .required("Identity Card / Passport is required")
            .matches(/^((?!-).)*$/g, 'Don\'t include "-" '),
        
        gender: Yup.string()
            .required("Gender is required"),
        
        dob: Yup.date()
            .max(new Date(), "Invalid date of birth, the date must be earlier than today")
            .required("Birth date is required"),

        nationality: Yup.string()
            .required("Nationality is required"),

        country: Yup.string()
            .required("Country is required"),
        
        city: Yup.string()
            .required("City is required"),
        
        state: Yup.string()
            .required("State is required"),

        address: Yup.string()
            .required("Address is required"),

        postcode: Yup.number()
            .required("Postcode is required"),
    });

    const countryList = require('../data/country.json');


    const submitForm2 = (values) => {
        // console.log(values);
        // console.log(userID);
        
        setSignUpErr(false);
        setLoading2(true);

        accountService.signUp2(values, userID)
            .then(response => {

                console.log(response); 

                if(response.status)
                {
                    const data = response.body.user;
                    let temp = {
                        firstname : data.firstname,
                        lastname : data.lastname,
                        phone: data.phone_no,
                        email : data.email,
                        password : '',
                        terms: true,
                    }
                    setUserData(temp);
                    setLoading2(false);
                    setSignUpStage(3);
                    clearTimer(getDeadTime());
                }
                else
                {
                    const err = response.body;
                    setSignUpErr(true);
                    setSignUpMessage('Something went wrong. Please try again');
                    setLoading2(false);
                }
                // setSignUpStage(3);
            })
            .catch(err => {
                console.error(err);
                setLoading2(false);
            });
    }

    const pinStyleCss = {
        padding : '10px'
    }
    const pinInputStyleCss = {
        borderColor : '#777',
        borderRadius : '8px',
        borderWidth : '1px',
        backgroundColor : 'rgba(57,56,62,0.75)',
        color : '#bbb'
    }
    const pinInputFocusStyleCss = {
        borderColor : 'royalblue',
        borderRadius : '8px',
        borderWidth : '2px',
        color : '#bbb'
    }

    const pinOnComplete = (value, index) => {
        setSignUpErr(false);
        setLoading3(true);

        accountService.verifySignUpOTP(userID, value)
            .then(response => {
                // console.log(response);
                if(response.status)
                {
                    navigate("/Login");
                    setLoading3(false);
                }
                else
                {
                    const err = response.body;
                    setSignUpErr(true);
                    setSignUpMessage(err.message);
                    setLoading3(false);
                }
            })
            .catch(err => {
                console.error(err);
                setLoading3(false);
            });
        
        // navigate("/");
    }

    const resendOTP = () => {
        // console.log(userID);
        // console.log(userData);
 
        accountService.resendOTP(userID)
            .then(response => {
                console.log(response);
            })
            .catch(err => {
                console.error(err);
            });

        clearTimer(getDeadTime());

    }

    const [timer, setTimer] = useState('0:00');

    const getTimeRemaining = (e) => {
        const total = Date.parse(e) - Date.parse(new Date());
        const seconds = Math.floor((total / 1000) % 60);
        const minutes = Math.floor((total / 1000 / 60) % 60);
        return {
            total, minutes, seconds
        };
    }

    const startTimer = (e) => {
        let { total, minutes, seconds } = getTimeRemaining(e);
        if (total >= 0) {
            setTimer(
                minutes + ':' + (seconds > 9 ? seconds : '0' + seconds)
            )
        }
    }

    const clearTimer = (e) => {
        setTimer('5:00');
 
        if (Ref.current) clearInterval(Ref.current);
        const id = setInterval(() => {
            startTimer(e);
        }, 1000)
        Ref.current = id;
    }

    const getDeadTime = () => {
        let deadline = new Date();
 
        deadline.setSeconds(deadline.getSeconds() + 300);
        return deadline;
    }

    // useEffect(() => {
    //     clearTimer(getDeadTime());
    // }, []);


    return (
        <Container fluid="lg" className='wrapper'>
            
            <Row className="RegisterMemberRow">

                <h1>Sign Up</h1>

                {signUpErr && (
                    <Col md={12} xs={12}>
                        <Alert variant="danger" onClose={() => setSignUpErr(false)} dismissible>
                            {signUpMessage}
                        </Alert>
                    </Col>
                )}

                {signUpStage===1 && (

                    <>
                        <Col xs={12} md={6} className="section left-divider">
                            
                            <Formik
                                initialValues={initialValues}
                                validationSchema={SignUpSchema1}
                                onSubmit={submitForm}
                            >
                                {({
                                    values,
                                    handleChange,
                                    handleSubmit,
                                    errors,
                                    touched,
                                    handleBlur,
                                    isValid,
                                    dirty
                                }) => (
                            
                                    <Form noValidate onSubmit={handleSubmit}>

                                        <Row className="mb-3">
                                            <Form.Group as={Col} md="12" controlId="validationCustom01">
                                                <Form.Label>First name</Form.Label>
                                                <Form.Control
                                                    required
                                                    name="firstname"
                                                    type="text"
                                                    placeholder="First name"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.firstname}
                                                    isValid={touched.firstname && !errors.firstname}
                                                    isInvalid={!!errors.firstname}
                                                    
                                                />
                                                <Form.Control.Feedback type="invalid">{errors.firstname}</Form.Control.Feedback>
                                            </Form.Group>
                                        </Row>

                                        <Row className="mb-3">
                                            <Form.Group as={Col} md="12" controlId="validationCustom02">
                                                <Form.Label>Last name</Form.Label>
                                                <Form.Control
                                                    required
                                                    name="lastname"
                                                    type="text"
                                                    placeholder="Last name"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.lastname}
                                                    isValid={touched.lastname && !errors.lastname}
                                                    isInvalid={!!errors.lastname}
                                                />
                                                <Form.Control.Feedback type="invalid">{errors.lastname}</Form.Control.Feedback>
                                            </Form.Group>
                                        </Row>
                                        
                                        <Row className="mb-3">
                                            <Form.Group as={Col} md="12" controlId="validationCustom03">
                                                <Form.Label>Email Address</Form.Label>
                                                <Form.Control
                                                    required
                                                    name="email"
                                                    type="text"
                                                    placeholder="Email address"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    isValid={touched.email && !errors.email}
                                                    isInvalid={!!errors.email}
                                                />
                                                <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
                                            </Form.Group>
                                        </Row>

                                        <Row className="mb-3">
                                            <Form.Group as={Col} md="12" controlId="validationCustom04">
                                                <Form.Label>Password</Form.Label>
                                                <Form.Control
                                                    required
                                                    name="password"
                                                    type="password"
                                                    placeholder="Password"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    isValid={touched.password && !errors.password}
                                                    isInvalid={!!errors.password}
                                                />
                                                <Form.Control.Feedback type="invalid">{errors.password}</Form.Control.Feedback>
                                            </Form.Group>
                                        </Row>

                                        <Form.Group className="mb-3" controlId="validationCustom05">
                                            <Form.Check
                                                required
                                                name="terms"
                                                label={(<>I have read and accept Kuching Marathon's <a target="_blank" href='https://www.marathonkuching.com/register/images/Signup T&C.pdf'>Terms & Condition</a> and {<a  target="_blank" href='https://www.marathonkuching.com/register/images/Privacy Policy.pdf'>Privacy Policy</a>} and consent to the processing of personal data.</>)}
                                                // label="Agree to terms and conditions"
                                                onChange={handleChange}
                                                isInvalid={!!errors.terms}
                                                feedback={errors.terms}
                                                feedbackType="invalid"
                                            />
                                        </Form.Group>

                                        <Row className="p-3">
                                            <Button type="submit" size="lg" className="red-button d-flex justify-content-center">
                                                Sign Up
                                                &nbsp;
                                                <TailSpin
                                                    height="30"
                                                    width="30"
                                                    color="#ccc"
                                                    ariaLabel="tail-spin-loading"
                                                    radius="1"
                                                    wrapperStyle={{}}
                                                    wrapperClass="loader"
                                                    visible={loading1}
                                                />
                                            </Button>
                                        </Row>

                                        <Row className="p-3 mb-3 text-center">
                                            <p>You already have an account? <a href="/register/Login">Login</a></p>
                                        </Row>

                                    </Form>

                                )}
                            </Formik>

                        </Col>

                        <Col xs={12} md={6} className="section">

                            <div className="rightNotice">
                                <Row id="noteTitle" className='justify-content-center align-items-center mb-3 '>
                                    <Col xs="4" md="3" lg="3">
                                        <img src={`${process.env.PUBLIC_URL}/images/exclaim-icon.png`} alt="" />
                                    </Col>
                                    <Col  xs="8" md="9" lg="9" className='align-middle'>
                                        <h2>Please take note</h2>
                                    </Col>
                                </Row>
                                <Row id="noteInfo">
                                    <p>
                                        Please check your registered <b>Email Mailbox/Spam Folder</b> for an OTP (One Time Password) after successful
                                    </p>
                                    <p>
                                        To activate the <b>NEW SIGN-UP account</b>, please insert this OTP at the required page.
                                    </p>
                                    <p>
                                        If you did not receive the OTP email kindly email <a href="mailto:support@marathonkuching.com">support@marathonkuching.com</a> immediately. You may also contact us via our social media handles.
                                    </p>
                                    <p>
                                        Thank you for registering for <br />
                                        <b>Kuching Marathon</b>
                                    </p>
                                </Row>
                            </div>

                            {/* <Row>
                                <img src={`${process.env.PUBLIC_URL}/images/reg_banner.jpg`} alt="" />
                            </Row> */}
                            
                            {/* <div className="loginButtonSection">

                                <Row>
                                    <img src={`${process.env.PUBLIC_URL}/images/register.png`} alt="" />
                                </Row>


                                <Row className="mb-3 text-center">
                                    <h5>Sign up without typing</h5>
                                    <hr />
                                </Row>

                                <Row className="mb-4">
                                    <FacebookLogin
                                        btnContent="LOGIN With Facebook"
                                        appId={FacebookAppID}
                                        autoLoad={false}
                                        fields="name,email,picture"
                                        scope="public_profile,email,user_friends"
                                        onSuccess={responseFacebook}
                                        onFail={responseFacebook}
                                        onProfileSuccess={responseFacebookProfile}
                                        render={(renderProps) => (
                                            <button id="facebook-btn" onClick={renderProps.onClick} disabled={renderProps.disabled}>
                                                <div className="btn-wrap">
                                                    <div className="logo">
                                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="24" height="24" fill="url(#pattern0)"></rect><defs><pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1"><use href="#image0_213_540" transform="scale(0.00769231)"></use></pattern><image id="image0_213_540" width="130" height="130" href="data:image/png;base64,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"></image></defs></svg>     
                                                    </div>
                                                    <span>Login with Facebook</span>
                                                </div>
                                            </button>
                                        )}
                                    />

                                    {login && (
                                            <div className="card">
                                            <div className="card-body">
                                                <img className="rounded" src={picture} alt="Profile" />
                                                <h5 className="card-title">{data.name}</h5>
                                                <p className="card-text">Email ID: {data.email}</p>
                                                <a href="#" className="btn btn-danger btn-sm" onClick={FacebookLogout}>
                                                Logout
                                                </a>
                                            </div>
                                            </div>
                                        )
                                    }
                                </Row>

                                <Row className="mb-4">
                                    <GoogleLogin
                                        clientId={GoogleClientID}
                                        buttonText="Sign in with Google"
                                        onSuccess={onGoogleSuccess}
                                        onFailure={onGoogleFailure}
                                        cookiePolicy={'single_host_origin'}
                                        isSignedIn={true}
                                        render={(renderProps) => (
                                            <button id="google-btn" onClick={renderProps.onClick} disabled={renderProps.disabled}>
                                                <div className="btn-wrap">
                                                    <div className="logo">
                                                        <svg width="18" height="18" xmlns="http://www.w3.org/2000/svg"><g fill="#000" fillRule="evenodd"><path d="M9 3.48c1.69 0 2.83.73 3.48 1.34l2.54-2.48C13.46.89 11.43 0 9 0 5.48 0 2.44 2.02.96 4.96l2.91 2.26C4.6 5.05 6.62 3.48 9 3.48z" fill="#EA4335"></path><path d="M17.64 9.2c0-.74-.06-1.28-.19-1.84H9v3.34h4.96c-.1.83-.64 2.08-1.84 2.92l2.84 2.2c1.7-1.57 2.68-3.88 2.68-6.62z" fill="#4285F4"></path><path d="M3.88 10.78A5.54 5.54 0 0 1 3.58 9c0-.62.11-1.22.29-1.78L.96 4.96A9.008 9.008 0 0 0 0 9c0 1.45.35 2.82.96 4.04l2.92-2.26z" fill="#FBBC05"></path><path d="M9 18c2.43 0 4.47-.8 5.96-2.18l-2.84-2.2c-.76.53-1.78.9-3.12.9-2.38 0-4.4-1.57-5.12-3.74L.97 13.04C2.45 15.98 5.48 18 9 18z" fill="#34A853"></path><path fill="none" d="M0 0h18v18H0z"></path></g></svg>
                                                    </div>
                                                    <span>Login with Google</span>
                                                </div>
                                            </button>
                                        )}
                                    />
                                </Row>
                                
                                <Row className="mb-5">
                                    <GoogleLogout
                                        clientId="658977310896-knrl3gka66fldh83dao2rhgbblmd4un9.apps.googleusercontent.com"
                                        buttonText="Logout"
                                        onLogoutSuccess={onGoogleLogout}
                                    />
                                </Row>
                            
                            </div> */}

                        </Col>
                    </>
                )}

                {signUpStage===2 && (
                    <>
                        <Formik
                                initialValues={initialValues2}
                                validationSchema={SignUpSchema2}
                                onSubmit={submitForm2}
                        >
                            {({
                                values,
                                handleChange,
                                handleSubmit,
                                errors,
                                touched,
                                handleBlur,
                                isValid,
                                dirty
                            }) => (
                                <Form noValidate onSubmit={handleSubmit}>

                                    <Row className="signUpForm2">

                                        <Form.Group as={Col} md="4" className="mb-3" controlId="validationCustom06">
                                            <Form.Label>Contact No.</Form.Label>
                                            <PhoneInput
                                                id="select-input"
                                                name="contact"
                                                className="form-control"
                                                country={'my'}
                                                inputProps={{
                                                    name: 'contact',
                                                }}
                                                value={values.contact}
                                                onChange={(phoneNumber, country, e)=>{handleChange(e)}}
                                                onBlur={handleBlur}
                                                isValid={touched.contact && !errors.contact}
                                                isInvalid={!!errors.contact}
                                            />
                                            <Form.Control isInvalid={!!errors.contact} hidden />
                                            <Form.Control.Feedback type="invalid">{errors.contact}</Form.Control.Feedback>
                                        </Form.Group>

                                        <Form.Group as={Col} md="3" className="mb-3" controlId="validationCustom07">
                                            <Form.Label>Identity Card / Passport</Form.Label>
                                            <Form.Control
                                                required
                                                name="mykad"
                                                type="text"
                                                placeholder=""
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.mykad}
                                                isValid={touched.mykad && !errors.mykad}
                                                isInvalid={!!errors.mykad}
                                            />
                                            <Form.Control.Feedback type="invalid">{errors.mykad}</Form.Control.Feedback>
                                        </Form.Group>

                                        <Form.Group as={Col} md="2" className="mb-3" controlId="validationCustom08">
                                            <Form.Label>Gender</Form.Label>
                                            <Form.Select
                                                aria-label="Default select example"
                                                name="gender"
                                                onChange={handleChange}
                                                isValid={touched.gender && !errors.gender}
                                                isInvalid={!!errors.gender}
                                            >
                                                <option key="" value="">Gender</option>
                                                <option key="Male" value="Male">Male</option>
                                                <option key="Female" value="Female">Female</option>
                                            </Form.Select>
                                            <Form.Control.Feedback type="invalid">{errors.gender}</Form.Control.Feedback>
                                        </Form.Group>

                                        <Form.Group as={Col} md="3" className="mb-3" controlId="validationCustom09">
                                            <Form.Label>Date of Birth</Form.Label>
                                            <Form.Control
                                                required
                                                name="dob"
                                                type="date"
                                                placeholder="dob"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.dob}
                                                isValid={touched.dob && !errors.dob}
                                                isInvalid={!!errors.dob}
                                            />
                                            <Form.Control.Feedback type="invalid">{errors.dob}</Form.Control.Feedback>
                                        </Form.Group>

                                        <Form.Group as={Col} md="4" className="mb-3" controlId="validationCustom10">
                                            <Form.Label>Nationality</Form.Label>
                                            <Form.Select
                                                aria-label="Default select example"
                                                name="nationality"
                                                onChange={handleChange}
                                                isValid={touched.nationality && !errors.nationality}
                                                isInvalid={!!errors.nationality}
                                            >
                                                <option key="" value="">Select a nationality</option>
                                                {
                                                    countryList.map(data => (
                                                        <option key={data.country} value={data.country}>{data.country}</option>
                                                    ))
                                                }
                                            </Form.Select>
                                            <Form.Control.Feedback type="invalid">{errors.nationality}</Form.Control.Feedback>
                                        </Form.Group>

                                        <Form.Group as={Col} md="4" className="mb-3" controlId="validationCustom12">
                                            <Form.Label>Country</Form.Label>
                                            <Form.Select
                                                aria-label="Default select example"
                                                name="country"
                                                onChange={handleChange}
                                                isValid={touched.country && !errors.country}
                                                isInvalid={!!errors.country}
                                            >
                                                <option key="" value="">Select a country</option>
                                                {
                                                    countryList.map(data => (
                                                        <option key={data.country} value={data.country}>{data.country}</option>
                                                    ))
                                                }
                                            </Form.Select>
                                            <Form.Control.Feedback type="invalid">{errors.country}</Form.Control.Feedback>
                                        </Form.Group>

                                        <Form.Group as={Col} md="4" className="mb-3" controlId="validationCustom13">
                                            <Form.Label>City</Form.Label>
                                            <Form.Control
                                                required
                                                name="city"
                                                type="text"
                                                placeholder="City"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.city}
                                                isValid={touched.city && !errors.city}
                                                isInvalid={!!errors.city}
                                            />
                                            <Form.Control.Feedback type="invalid">{errors.city}</Form.Control.Feedback>
                                        </Form.Group>

                                        <Form.Group as={Col} md="4" className="mb-3" controlId="validationCustom13">
                                            <Form.Label>state</Form.Label>
                                            <Form.Control
                                                required
                                                name="state"
                                                type="text"
                                                placeholder="State"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.state}
                                                isValid={touched.state && !errors.state}
                                                isInvalid={!!errors.state}
                                            />
                                            <Form.Control.Feedback type="invalid">{errors.state}</Form.Control.Feedback>
                                        </Form.Group>

                                        <Form.Group as={Col} md="2" className="mb-3" controlId="validationCustom14">
                                            <Form.Label>Postcode</Form.Label>
                                            <Form.Control
                                                required
                                                name="postcode"
                                                type="text"
                                                placeholder="Postcode"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.postcode}
                                                isValid={touched.postcode && !errors.postcode}
                                                isInvalid={!!errors.postcode}
                                            />
                                            <Form.Control.Feedback type="invalid">{errors.postcode}</Form.Control.Feedback>
                                        </Form.Group>

                                        <Form.Group as={Col} md="6" className="mb-3" controlId="validationCustom15">
                                            <Form.Label>Address</Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                rows={3}
                                                required
                                                name="address"
                                                type="text"
                                                placeholder="Address"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.address}
                                                isValid={touched.address && !errors.address}
                                                isInvalid={!!errors.address}
                                            />
                                            <Form.Control.Feedback type="invalid">{errors.address}</Form.Control.Feedback>
                                        </Form.Group>

                                        <Row className="p-3 ">
                                            <Button type="submit" size="lg" className="red-button d-flex justify-content-center">
                                                Sign Up &nbsp;
                                                <TailSpin
                                                    height="30"
                                                    width="30"
                                                    color="#ccc"
                                                    ariaLabel="tail-spin-loading"
                                                    radius="1"
                                                    wrapperStyle={{}}
                                                    wrapperClass="loader"
                                                    visible={loading2}
                                                />
                                            </Button>
                                        </Row>

                                    </Row>


                                    {/* <Col xs={12} md={6} className="section">
                                        <Row className="mb-3">
                                            <Form.Group as={Col} md="12" controlId="validationCustom06">
                                                <Form.Label>Contact No.</Form.Label>
                                                <PhoneInput
                                                    className="select-input form-control"
                                                    country={'us'}
                                                    value={values.contact}
                                                    onChange={handleChange}
                                                />
                                                <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                            </Form.Group>
                                        </Row>
                                        <Row className="mb-3">
                                            <Form.Group as={Col} md="12" controlId="validationCustom02">
                                                <Form.Label>Identity Card / Password</Form.Label>
                                                <Form.Control
                                                    required
                                                    name="Identity Card / Password"
                                                    type="text"
                                                    placeholder=""
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.mykad}
                                                    isValid={touched.mykad && !errors.mykad}
                                                    isInvalid={!!errors.mykad}
                                                />
                                                <Form.Control.Feedback type="invalid">{errors.mykad}</Form.Control.Feedback>
                                            </Form.Group>
                                        </Row>
                                        <Row className="mb-3">
                                            <Form.Group as={Col} md="12" controlId="validationCustom02">
                                                <Form.Label>Gender</Form.Label>
                                                <Form.Select
                                                    aria-label="Default select example"
                                                    name="gender"
                                                    onChange={handleChange}
                                                    isValid={touched.gender && !errors.gender}
                                                    isInvalid={!!errors.gender}
                                                >
                                                    <option disabled value="">Select your gender</option>
                                                    <option value="Male">Male</option>
                                                    <option value="Female">Female</option>
                                                </Form.Select>
                                                <Form.Control.Feedback type="invalid">{errors.lastname}</Form.Control.Feedback>
                                            </Form.Group>
                                        </Row>
                                        <Row className="mb-3">
                                            <Form.Group as={Col} md="12" controlId="validationCustom02">
                                                <Form.Label>Nationality</Form.Label>
                                                <Form.Select
                                                    aria-label="Default select example"
                                                    name="nationality"
                                                    onChange={handleChange}
                                                    isValid={touched.nationality && !errors.nationality}
                                                    isInvalid={!!errors.nationality}
                                                >
                                                    <option value="">Select a nationality</option>
                                                    {
                                                        countryList.map(data => (
                                                            <option value={data.country}>{data.country}</option>
                                                        ))
                                                    }
                                                </Form.Select>
                                                <Form.Control.Feedback type="invalid">{errors.nationality}</Form.Control.Feedback>
                                            </Form.Group>
                                        </Row>
                                        <Row className="mb-3">
                                            <Form.Group as={Col} md="12" controlId="validationCustom07">
                                                <Form.Label>Date of Birth</Form.Label>
                                                <Form.Control
                                                    required
                                                    name="dob"
                                                    type="date"
                                                    placeholder="dob"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.dob}
                                                    isValid={touched.dob && !errors.dob}
                                                    isInvalid={!!errors.dob}
                                                />
                                                <Form.Control.Feedback type="invalid">{errors.dob}</Form.Control.Feedback>
                                            </Form.Group>
                                        </Row>
                                    </Col>
                                    <Col xs={12} md={6} className="section">
                                        <Row className="mb-3">
                                            <Form.Group as={Col} md="12" controlId="validationCustom02">
                                                <Form.Label>Country</Form.Label>
                                                <Form.Select
                                                    aria-label="Default select example"
                                                    name="country"
                                                    onChange={handleChange}
                                                    isValid={touched.country && !errors.country}
                                                    isInvalid={!!errors.country}
                                                >
                                                    <option value="">Select a country</option>
                                                    {
                                                        countryList.map(data => (
                                                            <option value={data.country}>{data.country}</option>
                                                        ))
                                                    }
                                                </Form.Select>
                                                <Form.Control.Feedback type="invalid">{errors.country}</Form.Control.Feedback>
                                            </Form.Group>
                                        </Row>
                                        <Row className="mb-3">
                                            <Form.Group as={Col} md="12" controlId="validationCustom07">
                                                <Form.Label>State</Form.Label>
                                                <Form.Control
                                                    required
                                                    name="state"
                                                    type="text"
                                                    placeholder="State"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.state}
                                                    isValid={touched.state && !errors.state}
                                                    isInvalid={!!errors.state}
                                                />
                                                <Form.Control.Feedback type="invalid">{errors.state}</Form.Control.Feedback>
                                            </Form.Group>
                                        </Row>
                                        <Row className="mb-3">
                                            <Form.Group as={Col} md="12" controlId="validationCustom07">
                                                <Form.Label>City</Form.Label>
                                                <Form.Control
                                                    required
                                                    name="city"
                                                    type="text"
                                                    placeholder="City"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.city}
                                                    isValid={touched.city && !errors.city}
                                                    isInvalid={!!errors.city}
                                                />
                                                <Form.Control.Feedback type="invalid">{errors.city}</Form.Control.Feedback>
                                            </Form.Group>
                                        </Row>
                                        <Row className="mb-3">
                                            <Form.Group as={Col} md="12" controlId="validationCustom07">
                                                <Form.Label>Postcode</Form.Label>
                                                <Form.Control
                                                    required
                                                    name="postcode"
                                                    type="text"
                                                    placeholder="Postcode"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.postcode}
                                                    isValid={touched.postcode && !errors.postcode}
                                                    isInvalid={!!errors.postcode}
                                                />
                                                <Form.Control.Feedback type="invalid">{errors.postcode}</Form.Control.Feedback>
                                            </Form.Group>
                                        </Row>
                                        <Row className="mb-3">
                                            <Form.Group as={Col} md="12" controlId="validationCustom07">
                                                <Form.Label>Address</Form.Label>
                                                <Form.Control
                                                    as="textarea"
                                                    rows={3}
                                                    required
                                                    name="address"
                                                    type="text"
                                                    placeholder="Address"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.address}
                                                    isValid={touched.address && !errors.address}
                                                    isInvalid={!!errors.address}
                                                />
                                                <Form.Control.Feedback type="invalid">{errors.address}</Form.Control.Feedback>
                                            </Form.Group>
                                        </Row>
                                        
                                    </Col> */}
                                </Form>
                            )}
                        </Formik>
                    </>
                )}

                {signUpStage===3 && (
                    <>
                        <Col md={6}>
                            {/* <Row>
                                <img src={`${process.env.PUBLIC_URL}/images/reg_banner.jpg`} alt="" id="otp-logo" />
                            </Row> */}
                            <div className="rightNotice">
                                <Row id="noteTitle" className='justify-content-center align-items-center mb-3 '>
                                    <Col xs="4" md="3" lg="3">
                                        <img src={`${process.env.PUBLIC_URL}/images/exclaim-icon.png`} alt="" />
                                    </Col>
                                    <Col  xs="8" md="9" lg="9" className='align-middle'>
                                        <h2>Please take note</h2>
                                    </Col>
                                </Row>
                                <Row id="noteInfo">
                                    <p>
                                        Please check your registered <b>Email Mailbox/Spam Folder</b> for an OTP (One Time Password) after successful
                                    </p>
                                    <p>
                                        To activate the <b>NEW SIGN-UP account</b>, please insert this OTP at the required page.
                                    </p>
                                    <p>
                                        If you did not receive the OTP email kindly email <a href="mailto:support@marathonkuching.com">support@marathonkuching.com</a> immediately. You may also contact us via our social media handles.
                                    </p>
                                    <p>
                                        Thank you for registering for <br />
                                        <b>Kuching Marathon 2024</b>
                                    </p>
                                </Row>
                            </div>
                        </Col>

                        <Col md={6} className="text-center pin-section p-3">
                            {/* <p className="mb-5">
                                A one time pin (OTP) has been sent to the following email address. Please key-in the pin in the fields provided below.
                            </p> */}
                            <p className="mb-5 mt-5">
                                A one time pin (OTP) has been sent to your email. Please key-in the pin in the fields provided below.
                            </p>

                            {/* <h4>{userData.email}</h4> */}
                            <h4>{userData.email}</h4>

                            <h5 className="mb-5">Time Remaining: {timer}</h5>

                            <TailSpin
                                height="50"
                                width="50"
                                color="#fff"
                                ariaLabel="tail-spin-loading"
                                radius="1"
                                wrapperStyle={{margin: "0.5rem auto"}}
                                wrapperClass="loader"
                                visible={loading3}
                            />

                            <PinInput 
                                length={6} 
                                initialValue=""
                                // secret 
                                focus
                                onChange={(value, index) => {}} 
                                type="numeric" 
                                inputMode="number"
                                style={pinStyleCss}  
                                inputStyle={pinInputStyleCss}
                                inputFocusStyle={pinInputFocusStyleCss}
                                onComplete={pinOnComplete}
                                autoSelect={true}
                                regexCriteria={/^[ A-Za-z0-9_@./#&+-]*$/}
                            />

                            <br />

                            <a className="mt-3" onClick={resendOTP}>Resend OTP</a>
                            {/* <a className="mt-3" onClick={() => {console.log('test')}}>Prefer using email OTP</a> */}
                        </Col>
                    </>
                )}      

            </Row>
            
        </Container>
    );
}

export default RegisterMember;